<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <h2>Editando Função</h2>
      </div>
    </div>
    <div class="col-xs-12">
      <ng-include src="'views/funcoes/_form.html'"></ng-include>
    </div>
  </div>
</page-data-manager>
